const SITE_URL = (process.env.REACT_APP_SITE_URL || '').replace(/\/+$/, '');

export const fullUrl = (path) => `${SITE_URL}${path}`;

export const OG_IMAGE = `${SITE_URL}/og-image.png`;
export const LOGO_URL = `${SITE_URL}/logo192.png`;
export const SITE_NAME = 'Bangkok In Home Massage';

export const HREFLANG_CODES = [
  { code: 'ko', hreflang: 'ko', locale: 'ko_KR' },
  { code: 'en', hreflang: 'en', locale: 'en_US' },
  { code: 'zh', hreflang: 'zh', locale: 'zh_CN' },
  { code: 'ja', hreflang: 'ja', locale: 'ja_JP' },
  { code: 'th', hreflang: 'th', locale: 'th_TH' },
  { code: 'fr', hreflang: 'fr', locale: 'fr_FR' },
  { code: 'de', hreflang: 'de', locale: 'de_DE' },
  { code: 'es', hreflang: 'es', locale: 'es_ES' },
];

export const hreflangLinks = (path) =>
  HREFLANG_CODES.map(({ hreflang }) => ({
    rel: 'alternate',
    hreflang,
    href: `${SITE_URL}${path}?lang=${hreflang}`,
  })).concat({
    rel: 'alternate',
    hreflang: 'x-default',
    href: `${SITE_URL}${path}`,
  });

export const getLocale = (langCode) => {
  const found = HREFLANG_CODES.find((h) => h.code === langCode);
  return found ? found.locale : 'ko_KR';
};

export const buildBusinessSchema = (description) => ({
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  "name": SITE_NAME,
  "alternateName": "Thai Massage Booking",
  "description": description,
  "url": fullUrl('/'),
  "logo": LOGO_URL,
  "image": OG_IMAGE,
  "priceRange": "$$",
  "currenciesAccepted": "THB",
  "paymentAccepted": "Cash, Credit Card",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Bangkok",
    "addressRegion": "Bangkok",
    "addressCountry": "TH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 13.7563,
    "longitude": 100.5018
  },
  "areaServed": [
    { "@type": "City", "name": "Bangkok" },
    { "@type": "City", "name": "Pattaya" },
    { "@type": "City", "name": "Phuket" },
    { "@type": "City", "name": "Chiang Mai" },
    { "@type": "City", "name": "Korat" }
  ],
  "knowsLanguage": ["ko", "en", "zh", "ja", "th", "fr", "de", "es"],
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "10:00",
    "closes": "22:00"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "150",
    "bestRating": "5"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Massage Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Thai Traditional Massage",
          "description": "Authentic Thai massage with stretching and pressure point therapy",
          "serviceType": "Outcall Massage"
        },
        "price": "800",
        "priceCurrency": "THB"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Aroma Massage",
          "description": "Essential oil aromatherapy massage for deep relaxation",
          "serviceType": "Outcall Massage"
        },
        "price": "1000",
        "priceCurrency": "THB"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Swedish Massage",
          "description": "Full-body relaxation with long strokes and kneading techniques",
          "serviceType": "Outcall Massage"
        },
        "price": "1200",
        "priceCurrency": "THB"
      }
    ]
  },
  "potentialAction": {
    "@type": "ReserveAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": fullUrl('/booking'),
      "actionPlatform": [
        "http://schema.org/DesktopWebPlatform",
        "http://schema.org/MobileWebPlatform"
      ]
    },
    "result": {
      "@type": "Reservation",
      "name": "Massage Booking"
    }
  }
});

export const buildBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, i) => ({
    "@type": "ListItem",
    "position": i + 1,
    "name": item.name,
    "item": item.url,
  }))
});

export const buildFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((faq) => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer,
    }
  }))
});
